var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "net-info-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("setting.block")))
      ]),
      _vm._v(_vm._s(_vm.height || "----") + "\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("setting.version")))
      ]),
      _vm._v(_vm._s(_vm.version) + "\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "span",
        { staticClass: "a-link __pointer", on: { click: _vm.openEmail } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("setting.service")))
          ]),
          _c("span", { staticClass: "link" }, [_vm._v("info@vite.org")])
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "a-link __pointer",
          on: {
            click: function($event) {
              return _vm.go("https://vite.org/")
            }
          }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("setting.site")))
          ]),
          _c("span", { staticClass: "link" }, [_vm._v("vite.org")])
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "a-link __pointer", on: { click: _vm.goNet } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("setting.explorer")))
          ]),
          _c("span", { staticClass: "link" }, [_vm._v(_vm._s(_vm.netService))])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "span",
        {
          staticClass: "a-link __pointer",
          on: {
            click: function($event) {
              return _vm.go("https://vite.net/")
            }
          }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("setting.sys")))
          ]),
          _c("span", { staticClass: "link" }, [_vm._v("vite.net")])
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "a-link __pointer",
          on: {
            click: function($event) {
              return _vm.go("https://github.com/vitelabs")
            }
          }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("setting.open")))
          ]),
          _c("span", { staticClass: "link" }, [
            _vm._v("https://github.com/vitelabs")
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }